import React, { FC, ReactNode } from 'react';
import { Tooltip } from './Tooltip';
import { TooltipProps } from 'react-tooltip';

interface TooltipSetting {
  place?: string;
  type?: string;
  border?: boolean | string;
  className?: string;
}

interface LabelWithIconTooltip {
  tooltipLabel?: string;
  dataFor: string;
  tooltipBody: ReactNode | string;
  tooltipIcon: ReactNode;
  tooltipSetting: TooltipProps;
  wrapperClasses: string;
  labelClasses: string;
  dataTip?: boolean;
}

export const LabelWithIconTooltip: FC<LabelWithIconTooltip> = ({
  tooltipLabel,
  dataFor,
  dataTip = true,
  tooltipBody,
  tooltipIcon,
  tooltipSetting,
  wrapperClasses,
  labelClasses
}) => {
  return (
    <div className={wrapperClasses} data-testid='label-with-icon-tooltip'>
      <p className={labelClasses}>{tooltipLabel}</p>
      <Tooltip
        id={dataFor}
        place={tooltipSetting?.place || 'right'}
        type={tooltipSetting?.type || 'dark'}
        border={tooltipSetting?.border || false}
        className={tooltipSetting?.className || ''}
        visible
      >
        {tooltipBody}
      </Tooltip>
      <div className='h-full disabled:cursor-default cursor-pointer' data-tip={dataTip} data-for={dataFor}>
        {tooltipIcon}
      </div>
    </div>
  );
};
